import { enCentimes, formaterMontant } from './format';
import type { Inscription, TypeReduction } from '../types';

/**
 * Une ligne de reduction EN SAISIE : le type coche, et — pour une remise
 * libre — le montant tape et son motif. Les montants restent des chaines
 * tant qu'on saisit ; la conversion en centimes se fait a l'envoi.
 */
export interface SaisieLigneReduction {
  typeReductionId: string;
  montant: string;
  commentaire: string;
}

/** Le montant qu'une ligne vaudra : celui du type, ou celui tape pour une remise libre. */
export function montantLigneReduction(ligne: SaisieLigneReduction, types: TypeReduction[]): number {
  const type = types.find((t) => t.id === ligne.typeReductionId);
  if (!type) return 0;
  if (type.montant !== null) return type.montant;
  return enCentimes(ligne.montant || '0') ?? 0;
}

/** Le TOTAL que portera l'inscription : les lignes, plus la part non detaillee. */
export function totalReductions(
  lignes: SaisieLigneReduction[],
  types: TypeReduction[],
  nonDetaillee: number,
): number {
  return nonDetaillee + lignes.reduce((somme, ligne) => somme + montantLigneReduction(ligne, types), 0);
}

/**
 * L'infobulle d'une pastille « reduit » : chaque ligne avec son montant,
 * et la part non detaillee s'il en reste une.
 */
export function decrireReductions(
  i: Pick<Inscription, 'reduction' | 'reductions' | 'reduction_non_detaillee'>,
): string {
  const lignes = i.reductions.map(
    (l) => `${l.libelle} ${formaterMontant(l.montant)}${l.commentaire ? ` (${l.commentaire})` : ''}`,
  );
  if (i.reduction_non_detaillee > 0) {
    lignes.push(`Non détaillée ${formaterMontant(i.reduction_non_detaillee)}`);
  }
  return lignes.length > 0 ? lignes.join(' · ') : `Réduction de ${formaterMontant(i.reduction)}`;
}
